import React, { useState } from "react";
import "./AddPanelModal.css";
import { IoCloseOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { useLanguage } from "../../../LanguageProvider";
import AddModalInputField from "../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../ToasterProvider";

export default function AddPanelModal({ isOpen, onClose, onCreate }) {
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [panelTitle, setPanelTitle] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (panelTitle.trim() === "") {
      toastWarning(getTranslation("panelNameCantBeEmpty"));
      return;
    }
    onCreate(panelTitle);
    onClose();
    setPanelTitle("");
  };

  return (
    <div className="add-panel-modal-overlay">
      <div className="add-panel-modal-container">
        <IoCloseOutline
          className="add-panel-modal-button close"
          onClick={onClose}
        />

        <p className="add-panel-modal-title">
          {getTranslation("createNewPanel")}
        </p>

        <AddModalInputField icon={<TbStack2 size={22} style={{ width: "25px" }} />} placeholder={getTranslation("panelTitle") + "*"} value={panelTitle} onChange={(e) => setPanelTitle(e.target.value)} type={"text"} />

        <div className="add-panel-modal-actions">
          <button
            className="add-panel-modal-button create"
            onClick={handleCreate}
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
